import React, { useMemo } from 'react';
import { useQueryParams, StringParam } from 'use-query-params';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { getDatePickerRangeOptions, getDatePickerRangeLabel } from './utils';

const formatYMD = (date) => moment(date).format('YYYY-MM-DD');

/**
 * Handles the date range selected by the user
 */
export function useDateRange({ useFullDatePicker } = {}) {
  const [{ startDate: queryStartDate, endDate: queryEndDate }, setQuery] =
    useQueryParams({
      startDate: StringParam,
      endDate: StringParam,
    });

  const ranges = getDatePickerRangeOptions();

  // use the last 30 days by default
  const startDate = useMemo(
    () => (queryStartDate ? moment(queryStartDate) : ranges['Last 30 Days'][0]),
    [queryStartDate, ranges],
  );
  const endDate = useMemo(
    () => (queryEndDate ? moment(queryEndDate) : ranges['Last 30 Days'][1]),
    [queryEndDate, ranges],
  );
  const rangeLabel = useMemo(
    () => getDatePickerRangeLabel(ranges, startDate, endDate),
    [ranges, startDate, endDate],
  );
  const fullRangeLabel = useMemo(
    () =>
      [
        moment(startDate).format('YYYY/MM/DD'),
        moment(endDate).format('YYYY/MM/DD'),
      ].join(' - '),
    [startDate, endDate],
  );

  const picker = (
    <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      onApply={(event, newRange) => {
        setQuery({
          startDate: moment(newRange.startDate).toISOString(),
          endDate: moment(newRange.endDate).toISOString(),
        });
      }}
      ranges={ranges}
    >
      {useFullDatePicker ? (
        <div className="datepicker">
          <div className="datepicker-icon ">
            <i className="glyphicon glyphicon-calendar" />
          </div>
          {formatYMD(startDate)} – {formatYMD(endDate)}
        </div>
      ) : (
        <button
          type="button"
          className="btn btn-primary margin-left margin-right"
        >
          <i className="glyphicon glyphicon-calendar" />
        </button>
      )}
    </DateRangePicker>
  );

  return [startDate, endDate, picker, rangeLabel, fullRangeLabel];
}
